import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/issue/mutationTypes';

export default {
  [types.SET_ISSUES]: createSetPropMutation('issues', []),
  [types.CLEAR_ISSUES]: createClearPropMutation('issues', []),
  [types.SET_ISSUE_LIST_OPTIONS](state, options = {}) {
    state.issueListOptions = {
      ...(state.issueListOptions || {}),
      ...options,
    };
  },
  [types.SET_ISSUES_INNER_DATA]: createSetPropMutation('issuesInnerData', {}),
  [types.CLEAR_ISSUES_INNER_DATA]: createClearPropMutation('issuesInnerData', {}),

  [types.SET_ISSUE_DETAILS]: createSetPropMutation('issueDetails', {}),
  [types.CLEAR_ISSUE_DETAILS]: createClearPropMutation('issueDetails', {}),

};
